// extracted by mini-css-extract-plugin
export default {"container":"SoftwareVersions_container__PgfUi"};